export const GET_VEHICLE_SUCCESS = 'GET_VEHICLE_SUCCESS';
export const GET_VEHICLE_FAILURE = 'GET_VEHICLE_FAILURE';
export const GET_VEHICLE_REQUEST = 'GET_VEHICLE_REQUEST';
export const CLEAR_VEHICLE = 'CLEAR_VEHICLE';
